import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import { useEffect, useRef, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import AddAdviser from "./AddAdviser";
import { toast } from "react-toastify";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";

const Adviser = () => {
  const [showAddLeadershipCouncil, setShowAddLeadershipCouncil] =
    useState(false);
  const [leadershipCouncils, setLeadershipCouncils] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<
    string | null
  >(null);
  const [leadershipCouncilToEdit, setLeadershipCouncilToEdit] = useState<
    any | null
  >(null);
  const [search, setSearch] = useState("");
  const searchRef = useRef<string>("");
  const [totalCount, setTotalCount] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 10;
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getLeadershipCouncils();
  }, []);

  const getLeadershipCouncils = (keyword: string = "") => {
    WebService.getAPI({
      action: `advisers/get-advisers?keyword=${keyword}`,
    })
      .then((res: any) => {
           const perm = res?.data?.permissions || {};
      setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        const formattedRows = res?.data?.data.map((item: any) => ({
          ...item,
          originalImage: item.image,
          image: (
            <img
              src={item.image}
              alt={item.name}
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                objectFit: "contain",
              }}
            />
          ),
          action: (
            <div>
               {perm.canEdit && (
              <PencilFill
                className="me-3 cursor-pointer"
                onClick={() => {
                  setShowAddLeadershipCouncil(true);
                  setLeadershipCouncilToEdit(item);
                }}
                title="Edit"
              /> )}
              
              {perm.canDelete && (
              <TrashFill
                color="#DC143C"
                className="cursor-pointer"
                onClick={() => handleDeleteEvent(item._id)}
                title="Delete"
              />  )}
            </div>
          ),
        }));
        setLeadershipCouncils(formattedRows);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {});
  };

  const handleReorder = (newRows: any) => {
    setLeadershipCouncils(newRows);

    const reorderedPayload = newRows.map((item: any, index: number) => ({
      _id: item._id,
      order_by: index + 1,
    }));

    WebService.postAPI({
      action: "advisers/update-order",
      body: reorderedPayload,
    })
      .then(() => {})
      .catch(() => {
        toast.error("Failed to update order");
      });
  };
  const handleDeleteEvent = (leadershipCouncilId: string) => {
    setLeadershipCouncilToDelete(leadershipCouncilId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddAdviser
        show={showAddLeadershipCouncil}
        handleClose={() => {
          setShowAddLeadershipCouncil(false);
          setLeadershipCouncilToEdit(null);
          getLeadershipCouncils(searchRef.current);
        }}
        data={leadershipCouncilToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (leadershipCouncilToDelete) {
            WebService.deleteAPI({
              action: `advisers/deleteAdviser/${leadershipCouncilToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getLeadershipCouncils(searchRef.current);
            });
          }
        }}
        message="Are you sure you want to delete this adviser?"
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Advisor</div>
            {pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add"
              onClick={() => {
                setLeadershipCouncilToEdit(null);
                setShowAddLeadershipCouncil(true);
              }}
              style={{ width: 100 }}
            /> )}
          </div>
          <div className="row">
            <div className="col-md-3">
              <Form.Label className="label">Search</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                value={search}
                onChange={(e) => {
                  const value = e.target.value;
                  searchRef.current = value;                  
                  setSearch(value);
                  getLeadershipCouncils(searchRef.current);
                }}
              />
            </div>
          </div>          
          <CustomTableSortable
            columns={[
              { id: "image", label: "Image", minWidth: 100, align: "center" },
              { id: "name", label: "Name", minWidth: 100, align: "center" },
              {
                id: "designation",
                label: "Designation",
                minWidth: 100,
                align: "center",
              },

              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={leadershipCouncils}
             totalCount={0}
            currentPage={1}
            pageSize={10}
            onPageChange={() => { }}
            draggable // 👈 enable drag
            onRowsReorder={handleReorder} // 👈 handle dropping
            pagination={false}
          />
        </Card>
      </div>
    </>
  );
};

export default Adviser;
